import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgSelectLayoutComponent } from '../ng-select-layout/ng-select-layout.component';
import { NgSelectListModel } from 'src/app/core/models/ng-select-list.model';

@Component({
  selector: 'app-ng-select-layout-filter',
  templateUrl: './ng-select-layout-filter.component.html',
  styleUrls: ['./ng-select-layout-filter.component.scss']
})
export class NgSelectLayoutFilterComponent extends NgSelectLayoutComponent{

  @Input() statusSelected: any = undefined;
  
  @Output() statusChanged = new EventEmitter<any>();
}
